//importing firebase
import {signInWithEmailAndPassword, signOut} from "firebase/auth";
import {Auth, } from "../firebase";




export function fbLogin(validatorOutput) {
    const email = validatorOutput.username;
    const password = validatorOutput.password;

    signInWithEmailAndPassword(Auth, email, password)
        .then((user) => {

        })
        .catch(error => {
            console.error("Failed to sign in. ", error.message);
        });


}
